import { render } from "./IconItemCategoryTicket.vue?vue&type=template&id=30a05813"
import script from "./IconItemCategoryTicket.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__